// The two bucket ladders shared by the client charts (Overview) and the
// heatmap axes (Conversions): maturity bands and notional bands.
//
// These are NOT the canonical 8 tenor buckets in flowSightTenor.js. Those drive
// the tenor index that chart1, the bubble and the split chart on the Conversions
// tab are keyed by, plus the global period filter - widening them there moves
// numbers across the whole app. These coarser 5-band ladders exist purely to
// keep an axis readable, and every chart that shows "faixa de vencimento" or
// "faixa notional" as a LABEL must read them from here.
export const MATURITY_BUCKETS = [
  { label: '1-30D', max: 30 },
  { label: '31-90D', max: 90 },
  { label: '91-180D', max: 180 },
  { label: '181-360D', max: 360 },
  { label: '>=361D', max: Infinity },
]

export const VOLUME_BUCKETS = [
  { label: '0-100k', max: 1e5 },
  { label: '100k-1M', max: 1e6 },
  { label: '1M-5M', max: 5e6 },
  { label: '5M-15M', max: 15e6 },
  { label: '>15M', max: Infinity },
]

export const MATURITY_LABELS = MATURITY_BUCKETS.map((b) => b.label)
export const VOLUME_LABELS = VOLUME_BUCKETS.map((b) => b.label)

const indexIn = (buckets, value) => {
  const i = buckets.findIndex((b) => value <= b.max)
  return i === -1 ? buckets.length - 1 : i
}

export const maturityIndexFromDays = (days) => indexIn(MATURITY_BUCKETS, Number(days) || 0)
export const volumeIndexFromNotional = (notional) => indexIn(VOLUME_BUCKETS, Number(notional) || 0)

export const maturityLabelFromDays = (days) => MATURITY_BUCKETS[maturityIndexFromDays(days)].label
export const volumeLabelFromNotional = (notional) => VOLUME_BUCKETS[volumeIndexFromNotional(notional)].label
